<template>
	<div>
		<b-row class="align-items-center">
			<b-col cols="6">
				<b-button variant="link" @click="emitEvent('go-back-to-chat-main')" class="px-0">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<path fill="currentColor" d="m14 18-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6L14 18Z" />
					</svg>
					Back
				</b-button>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12">
				<h3 class="font-weight-500">Edit Group</h3>
			</b-col>
		</b-row>
		<b-form role="form" @submit.prevent="updateGroup">
			<b-row>
				<!-- <b-col cols="12">
                    <b-form-group>
                        <b-form-radio-group
                            v-model="current_group.type"
                            :options="typeOptions"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col> -->
				<b-col cols="12">
					<b-form-group label="Group Name">
						<b-form-input v-model="current_group.name" type="text" required></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<edit-group-member :currentGroup="detailGroup" :groupType="current_group.type" :initMember="initMessageMember" @update="setSelectedParticipant($event)"></edit-group-member>
				</b-col>
				<b-col cols="12" class="text-center">
					<b-button type="button" variant="danger" class="py-2 px-5 mx-1 mt-5" @click="exitGroup(detailGroup)"
						v-if="!_gAuth.isCorporateOwner()">Exit Group</b-button>
					<b-button type="submit" variant="primary" class="py-2 px-5 mx-1 mt-5">Update Group</b-button>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>
<script>
import { Select, Option } from 'element-ui'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import { swal } from '@/assets/js/httpImports.js'
import EditGroupMember from '@/views/Messaging/Chats/EditGroupMember'

export default {
	props: {
		showEditGroup: Boolean,
		showMainPage: Boolean,
		showChatRooms: Boolean,
	},
	components: {
		EditGroupMember,
		[Option.name]: Option,
		[Select.name]: Select,
	},
	data() {
		return {
			initMessageMember:false,
			detailGroup: null,
			selectedIds: [],
			newIds: [],
			removeIds: [],
			selectedAdminIds: [],
			newAdminIds: [],
			removeAdminIds: [],
			current_group: {
				id: '',
				bundle_key: '',
				name: '',
				type: '',
				group_channel_type: ''
			},
			typeOptions: [
				{ text: 'Internal', value: 'internal' },
				{ text: 'External', value: 'external' },
			]
		}
	},
	watch: {
		message_profile: {
			handler(newVal) {
				this.resetData()
			},
			immediate: true
		},
		showEditGroup: {
			handler(newVal) {
				this.initMessageMember = newVal
			},
			immediate: true
		},
		selected_group: {
			handler(newVal) {
				if (newVal) {
					this.detailGroup = newVal
					this.current_group.id = newVal.group_id
					this.current_group.name = newVal.group_name
					this.current_group.type = newVal.group_type
					this.current_group.bundle_key = newVal.group_bundle_key
					this.current_group.group_channel_type = newVal.group_channel_type
					this.selectedIds = (!_gHlp.isEmpty(newVal.group_participants)) ? newVal.group_participants.map(o => o.participant_user_id) : []
					this.selectedAdminIds = (!_gHlp.isEmpty(newVal.group_participants)) ? newVal.group_participants.filter(x => x.gmp_is_admin == 1).map(o => o.participant_user_id) : []
				}
			},
			immediate: true
		}
	},
	computed: {
		...mapState(useMessagingStore, ['selected_group', 'available_user_list', 'message_profile']),
	},
	methods: {
		...mapActions(useMessagingStore, ['getGroupMessageList', 'updateGroupMessage', 'createInfoMessage']),
		emitEvent(eventName) {
			chatEventBus.$emit(eventName)
			if (eventName === 'go-back-to-chat-main') {
				this.getGroupMessageList(_gHlp.getValue(this.message_profile,'message_group_bundle_key'))
				this.resetData()
			}
		},
		async updateGroup() {
			const groupCurrent = this.current_group
			const postData = {
				group_name: this.current_group.name,
				group_type: this.current_group.type,
				group_channel_type: this.current_group.group_channel_type,
				group_bundle_key: this.current_group.bundle_key,
				group_participants: []
			}
			// Selected IDs and get all its objects
			const activeUser = _gAuth.activeUser()

			//AUTO SET CREATOR TO PARTICIPANT
			if (!_gHlp.isEmpty(activeUser) && activeUser.id == groupCurrent.group_created_by) {
				postData.group_participants.push({
					participant_user_id: activeUser.id,
					participant_username: activeUser.name,
					participant_fullname: activeUser.name,
					participant_photo_profile: null,
					gmp_is_admin: 1
				});
			}

			let adminUserIds = this.selectedAdminIds;
			this.selectedIds.forEach(selectedId => {
				const selectedUser = this.available_user_list.find(user => user.id == selectedId)
				if (selectedUser) {
					if (selectedUser.id != groupCurrent.group_created_by) {
						let isAdmin = adminUserIds.includes(selectedUser.id) ? 1 : 0;
						postData.group_participants.push({
							participant_user_id: selectedUser.id,
							participant_username: selectedUser.name,
							participant_fullname: selectedUser.name,
							participant_photo_profile: null,
							gmp_is_admin: isAdmin
						});
					}
				}
			});
			let status = await this.updateGroupMessage(this.current_group.id, postData)
			if (status) {
				//GET INFO MESSAGES
				if (!_gHlp.isEmpty(this.newIds)) {
					for (let i = 0; i < this.newIds.length; i++) {
						const uid = this.newIds[i];
						this.createInfoMessage('ADD_MEMBER', this.current_group.id, uid)
					}
				}
				if (!_gHlp.isEmpty(this.removeIds)) {
					for (let i = 0; i < this.removeIds.length; i++) {
						const uid = this.removeIds[i];
						this.createInfoMessage('REMOVE_MEMBER', this.current_group.id, uid)
					}
				}

				this.emitEvent('go-back-to-chat-main')
			}
		},
		exitGroup(group) {
			swal.fire({
				title: 'Are you sure to leave this group ?',
				text: "After leaving this group, you can no longer see the group and messages in this group",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, Leave !',
			}).then(async (result) => {
				/* Read more about isConfirmed, isDenied below */
				if (result.isConfirmed) {

					let activeUserId = _gAuth.activeUserId();
					let newParticipants = [];

					group.group_participants.forEach((o) => {
						if (o.participant_user_id != activeUserId) {
							newParticipants.push({
								participant_user_id: o.participant_user_id,
								participant_username: o.participant_username,
								participant_fullname: o.participant_fullname,
								participant_photo_profile: o.participant_photo_profile,
								gmp_is_admin: o.gmp_is_admin,
							});
						}
					});

					let updateParams = {
						group_name: group.group_name,
						group_type: group.group_type,
						group_channel_type: group.group_channel_type,
						group_bundle_key: group.group_bundle_key,
						group_participants: newParticipants
					}
					let status = await this.updateGroupMessage(group.group_id, updateParams)
					if (status) {
						this.createInfoMessage('EXIT_GROUP', group.group_id, 0)
						this.emitEvent('go-back-to-chat-main')
						_gNotif.notifySuccess('You Already Exit From Group');
					}
				}
			})

		},
		setSelectedParticipant(params) {
			this.selectedIds = params.listSelectedIds
			this.newIds = params.listNewIds
			this.removeIds = params.listRemoveIds

			this.selectedAdminIds = params.listSelectedAdminIds
			this.newAdminIds = params.listNewAdminIds
			this.removeAdminIds = params.listRemoveAdminIds
		},
		resetData() {
			this.detailGroup = null

			this.selectedIds = []
			this.newIds = []
			this.removeIds = []

			this.selectedAdminIds = []
			this.newAdminIds = []
			this.removeAdminIds = []

			this.current_group = {
				id: '',
				bundle_key: '',
				name: '',
				type: '',
				group_channel_type: ''
			}
		},
	}
}
</script>